import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Paper,
  Avatar,
  TextField,
  Button,
  Stack,
  Typography,
  Link,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import LockIcon from "@mui/icons-material/Lock";
import { pink } from "@mui/material/colors";
import Validation from "../Validation/Validation";
import { userLogin } from "../services/Auth";
import { useHistory } from "react-router";
import { Email } from "@mui/icons-material";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { approveBill } from "../services/Sales";
import { approveImportBill, approveImportReturnBill } from "../services/Import";
// import { Link } from 'react-router-dom';

const useStyles = makeStyles({
  paper: {
    padding: "20px",
    //   height:"{{ xs: 1, sm: 1, md: 3 }}",
    width: "40vh",
    margin: "20vh auto",
  },
  header: {
    marginTop: "0px",
  },
  headerTxt: {
    marginTop: "0px",
  },
});

function EmailAuthentication(props) {
  const history = useHistory();
  const { billCategory, billId, approved } = useParams();
  const [showError, setShowError] = useState("");

  const [values, setValues] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const hanldeFormSubmit = async (event) => {
    event.preventDefault();
    setErrors(Validation(values));
    if (!errors || errors !== {} || errors.length !== 0) {
      let result = await userLogin(values.email, values.password);
      console.log("result--", result);
      if (result === "done") {
        console.log("Bill Id: ", billId);
        // history.push("/template/home");
        if (billCategory === "sale") {
          let approveResult = await approveBill(billId, approved);
          if (approveResult === "Unable to approve the bill...") {
            setShowError(approveResult);
          }
        } else if (billCategory === "import-bill") {
          let approveResult = await approveImportBill(billId, approved);
          if (approveResult === "Unable to approve the bill...") {
            setShowError(approveResult);
          }
        }else if (billCategory === "import-return-bill") {
          let approveResult = await approveImportReturnBill(billId, approved);
          if (approveResult === "Unable to approve the bill...") {
            setShowError(approveResult);
          }
        }
      } else {
        setShowError(result);
      }
    }
  };

  const resetError = (event) => {
    setErrors({});
  };

  const classes = useStyles();
  return (
    <Grid>
      <Paper elevation={10} className={classes.paper}>
        <Grid
          align="center"
          className={classes.header}
          container
          spacing={{ xs: 0, sm: 1, md: 1 }}
        >
          <Grid item xs={12}>
            <h2>NORTEL (PVT)LTD </h2>
          </Grid>
          <Grid item xs={12}>
            <Avatar sx={{ bgcolor: pink[500] }}>
              <LockIcon />
            </Avatar>
          </Grid>
          <Grid item xs={12}>
            <h3 className={classes.headerTxt}>Sign in</h3>
          </Grid>
          <Grid item>
            {showError ? (
              <Grid container>
                <Typography
                  align="left"
                  variant="caption"
                  style={{
                    color: "red",
                    fontSize: 16,
                    fontWeight: "bold",
                    paddingLeft: 40,
                  }}
                >
                  {showError}
                </Typography>
              </Grid>
            ) : null}
          </Grid>
          <Grid item xs={12}>
            <Stack direction={"column"} spacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid
                container
                direction={"column"}
                columnSpacing={{ xs: 1, sm: 1, md: -1 }}
              >
                <Grid item>
                  <TextField
                    error={errors.email}
                    id="email"
                    type="email"
                    label="Email"
                    variant="standard"
                    fullWidth
                    required
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    className={classes.inputContainer}
                    helperText={errors.email}
                    onClick={resetError}
                  />
                </Grid>
                <Grid item>
                  <TextField
                    error={errors.password}
                    id="filled-password-input"
                    label="Password"
                    type="password"
                    autoComplete="current-password"
                    variant="standard"
                    fullWidth
                    required
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    className={classes.inputContainer}
                    helperText={errors.password}
                    onClick={resetError}
                  />
                </Grid>
              </Grid>
              <Button
                className={classes.btnSignin}
                variant="contained"
                fullWidth
                onClick={hanldeFormSubmit}
              >
                Sign in
              </Button>
            </Stack>
            {/* <Typography
              align="center"
              sx={{ m: 2 }}
              className={classes.forgotpss}
            >
              <Link href="#" underline="hover">
                Forgot password?
              </Link>
            </Typography>
            <Typography align="center" sx={{ m: 2 }}>
              Sign up? <a href="/register">Sign up</a>
            </Typography> */}
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}

EmailAuthentication.propTypes = {};

export default EmailAuthentication;
